
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"54","viewBox":"0 0 48 54","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.49999 52.9803L45.5 30.4637C48.1667 28.9241 48.1667 25.0751 45.5 23.5355L6.5 1.01879C3.83333 -0.520814 0.5 1.40368 0.5 4.48288L0.499998 49.5162C0.499998 52.5954 3.83333 54.5199 6.49999 52.9803Z","fill":"white"}})])
          )
        }
      }
    